import React, { useState } from 'react';
import { generateProductContent } from '../services/aiService';
import { LANGUES_45 } from '../types';
import { ErrorBanner, LoadingOverlay } from '../components/UIStates';

const Generator: React.FC = () => {
  const [form, setForm] = useState({ produit: '', cible: '', prix: '', objectif: 'ventes', description: '', plateforme: 'linkedin', ton: 'professionnel', langue: 'Français' });
  const [results, setResults] = useState<Record<string, string> | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState('');

  const handle = async () => {
    setError('');
    if (!form.produit.trim()) { setError('Renseignez le nom du produit.'); return; }
    if (!form.cible.trim()) { setError('Renseignez la cible.'); return; }
    setLoading(true); setResults(null);
    try {
      setResults(await generateProductContent(form));
    } catch (e: any) {
      setError(e?.message || "La génération a échoué. Réessayez.");
      console.error('[Generator]', e);
    }
    setLoading(false);
  };

  const copy = (text: string, label: string) => { navigator.clipboard.writeText(text); setCopied(label); setTimeout(() => setCopied(''), 2000); };
  const inp: React.CSSProperties = { width: '100%', background: '#252540', border: '1px solid #3A3A5C', borderRadius: 10, padding: '12px 14px', color: '#F8F7FF', fontSize: 14, outline: 'none', boxSizing: 'border-box' };

  const types = [
    { key: 'post_linkedin', icon: '💼', label: 'Post LinkedIn' },
    { key: 'hook_viral', icon: '🎣', label: 'Hooks viraux' },
    { key: 'script_video', icon: '🎬', label: 'Script vidéo' },
    { key: 'email_prospect', icon: '📧', label: 'Email prospect' },
  ];

  return (
    <div style={{ padding: 32 }}>
      <div style={{ fontSize: 28, fontWeight: 800, color: '#F8F7FF', marginBottom: 6 }}>✨ Générateur de contenu</div>
      <div style={{ color: '#C8C8E8', fontSize: 14, marginBottom: 20 }}>Décris ton produit, l'IA crée le contenu qui vend</div>
      <ErrorBanner message={error} onRetry={handle} onDismiss={() => setError('')} />
      {loading && <LoadingOverlay label="Génération du contenu" step="L'IA rédige vos textes…" />}
      <div style={{ background: '#1A1A2E', border: '1px solid #3A3A5C', borderRadius: 20, padding: 28, marginBottom: 20 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          <div><label style={{ fontSize: 13, color: '#C8C8E8', display: 'block', marginBottom: 6 }}>Produit *</label><input style={inp} placeholder="ex: ContenuIA" value={form.produit} onChange={e => setForm({ ...form, produit: e.target.value })} /></div>
          <div><label style={{ fontSize: 13, color: '#C8C8E8', display: 'block', marginBottom: 6 }}>Cible *</label><input style={inp} placeholder="ex: Entrepreneurs, PME" value={form.cible} onChange={e => setForm({ ...form, cible: e.target.value })} /></div>
          <div><label style={{ fontSize: 13, color: '#C8C8E8', display: 'block', marginBottom: 6 }}>Prix</label><input style={inp} placeholder="79€/mois" value={form.prix} onChange={e => setForm({ ...form, prix: e.target.value })} /></div>
          <div><label style={{ fontSize: 13, color: '#C8C8E8', display: 'block', marginBottom: 6 }}>Objectif</label>
            <select style={inp} value={form.objectif} onChange={e => setForm({ ...form, objectif: e.target.value })}>
              <option value="ventes">Ventes</option><option value="leads">Leads</option><option value="notoriété">Notoriété</option><option value="abonnés">Abonnés</option>
            </select></div>
          <div style={{ gridColumn: '1/-1' }}><label style={{ fontSize: 13, color: '#C8C8E8', display: 'block', marginBottom: 6 }}>Description</label><textarea style={{ ...inp, minHeight: 70, resize: 'vertical' }} placeholder="Décris ton offre..." value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} /></div>
          <div><label style={{ fontSize: 13, color: '#C8C8E8', display: 'block', marginBottom: 6 }}>Plateforme</label>
            <select style={inp} value={form.plateforme} onChange={e => setForm({ ...form, plateforme: e.target.value })}>
              <option value="linkedin">LinkedIn</option><option value="instagram">Instagram</option><option value="tiktok">TikTok</option><option value="facebook">Facebook</option><option value="tous">Tous</option>
            </select></div>
          <div><label style={{ fontSize: 13, color: '#C8C8E8', display: 'block', marginBottom: 6 }}>Langue</label>
            <select style={inp} value={form.langue} onChange={e => setForm({ ...form, langue: e.target.value })}>
              {LANGUES_45.map(l => <option key={l}>{l}</option>)}
            </select></div>
        </div>
        <button onClick={handle} disabled={loading} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, padding: '16px 32px', background: 'linear-gradient(135deg,#6C47FF,#8B6FFF)', border: 'none', borderRadius: 14, color: 'white', fontSize: 16, fontWeight: 700, cursor: 'pointer', marginTop: 20, width: '100%', opacity: loading ? 0.6 : 1 }}>
          {loading ? '⏳ Génération...' : '✨ Générer le contenu'}
        </button>
      </div>
      {results && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          {types.map(t => (
            <div key={t.key} style={{ background: '#1A1A2E', border: '1px solid #3A3A5C', borderRadius: 16, padding: 20 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: '#8B6FFF' }}>{t.icon} {t.label}</span>
                <button onClick={() => copy(results[t.key] || '', t.label)} style={{ background: 'none', border: '1px solid #3A3A5C', borderRadius: 6, padding: '4px 10px', color: copied === t.label ? '#00F5A0' : '#C8C8E8', fontSize: 11, cursor: 'pointer' }}>
                  {copied === t.label ? '✅' : '📋'}
                </button>
              </div>
              <div style={{ fontSize: 13, lineHeight: 1.7, color: '#C8C8E8', whiteSpace: 'pre-wrap' }}>{(results[t.key] || '').substring(0, 500)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default Generator;
